export { default as HeroImage } from './HeroImage';
